/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevenueMonthData
 */
export interface RevenueMonthData {
    /**
     * 
     * @type {Date}
     * @memberof RevenueMonthData
     */
    month: Date;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    totalRefunds: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    totalPayments: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    totalCredits: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    totalDebits: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    classRevenue: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueMonthData
     */
    ticketRevenue: number;
}

/**
 * Check if a given object implements the RevenueMonthData interface.
 */
export function instanceOfRevenueMonthData(value: object): value is RevenueMonthData {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('totalRefunds' in value) || value['totalRefunds'] === undefined) return false;
    if (!('totalPayments' in value) || value['totalPayments'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('totalCredits' in value) || value['totalCredits'] === undefined) return false;
    if (!('totalDebits' in value) || value['totalDebits'] === undefined) return false;
    if (!('classRevenue' in value) || value['classRevenue'] === undefined) return false;
    if (!('ticketRevenue' in value) || value['ticketRevenue'] === undefined) return false;
    return true;
}

export function RevenueMonthDataFromJSON(json: any): RevenueMonthData {
    return RevenueMonthDataFromJSONTyped(json, false);
}

export function RevenueMonthDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevenueMonthData {
    if (json == null) {
        return json;
    }
    return {
        
        'month': (new Date(json['month'])),
        'totalRefunds': json['totalRefunds'],
        'totalPayments': json['totalPayments'],
        'revenue': json['revenue'],
        'totalCredits': json['totalCredits'],
        'totalDebits': json['totalDebits'],
        'classRevenue': json['classRevenue'],
        'ticketRevenue': json['ticketRevenue'],
    };
}

export function RevenueMonthDataToJSON(json: any): RevenueMonthData {
    return RevenueMonthDataToJSONTyped(json, false);
}

export function RevenueMonthDataToJSONTyped(value?: RevenueMonthData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'].toISOString().substring(0,10),
        'totalRefunds': value['totalRefunds'],
        'totalPayments': value['totalPayments'],
        'revenue': value['revenue'],
        'totalCredits': value['totalCredits'],
        'totalDebits': value['totalDebits'],
        'classRevenue': value['classRevenue'],
        'ticketRevenue': value['ticketRevenue'],
    };
}

